/**
 * Rebuy cart payloads mirror Shopify cart money fields: amounts are in the
 * shop's minor currency unit (e.g. cents for USD).
 */
function rebuyCartCurrencyIso(cart) {
  const c = cart?.currency;
  if (typeof c === 'string' && c) return c;
  if (c && typeof c.iso_code === 'string') return c.iso_code;
  return 'USD';
}

function formatMinorUnits(amountCents, currencyCode) {
  try {
    return new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency: currencyCode,
    }).format(amountCents / 100);
  } catch {
    return (amountCents / 100).toFixed(2);
  }
}

const REBUY_ANNOUNCEMENT_DEFAULT_HTML =
  '<span>A portion of every bottle is donated to <a href="https://grapesforglioblastoma.org/" target="_blank">Grapes for Glioblastoma</a></span>';

document.addEventListener('rebuy:cart.change', (event) => {
  const cart = event.detail?.cart?.cart;
  const subtotalCents = cart?.items_subtotal_price;

  if (cart == null || typeof subtotalCents !== 'number' || Number.isNaN(subtotalCents)) {
    return;
  }

  const tenPercentCents = Math.round(subtotalCents * 0.1);

  document.querySelectorAll('[data-rebuy-component="announcement-bar"] .message').forEach((element) => {
    if (subtotalCents <= 0) {
      element.innerHTML = REBUY_ANNOUNCEMENT_DEFAULT_HTML;
      return;
    }

    const formatted = formatMinorUnits(tenPercentCents);

    element.innerHTML = `
            <div class="rebuy-cart__announcement-bar">
                <div class="rebuy-cart__announcement-bar-inner">
                    <div class="rebuy-cart__announcement-bar-text">
                        <span>You are donating $${formatted} to <a href="https://grapesforglioblastoma.org/" target="_blank">Grapes for Glioblastoma</a></span>
                    </div>
                </div>
            </div>
        `;
  });
});
